import script from "./TabClasificacionEquiposIndividual.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabClasificacionEquiposIndividual.vue?vue&type=script&setup=true&lang=ts"

import "./TabClasificacionEquiposIndividual.vue?vue&type=style&index=0&id=a5b16080&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5b16080"]])

export default __exports__